import swaggerClient from "./../remote-client";
import Utils from "../Utils";

export default class HFManagementServiceImpl {
  // FETCH HF INFORMATION
  fetchHF(hfId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacility.getHfWithId(
            {
              id: hfId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchGeneralInfo(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacility.getGeneralInfoOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  updateOfficeGeneralInfo(officeId, officeGeneralInfo) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postGeneralInfoOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(officeGeneralInfo),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchDoctorServiceList(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getDoctorsServiceOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.doctorServiceList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // FETCH LIST OF DOCTORS FOR A SPECIFIC SERVICE
  fetchDoctorsListOfService(officeId, serviceId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityAppointmentsManagement.getDoctorsOfficeWithIdServiceWithServiceId(
            {
              id: officeId,
              serviceId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.doctors;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchDimension(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacility.getDimensionOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.dimension;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  updateDimension(officeId, dimension) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postDimensionOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(dimension),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // FETCH SERVICES OF A SPECIFIC OFFICE
  fetchHFServices(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getServicesOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.serviceList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // fondoest/issues#1436
  fetchHFServicesForAppointment(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getServicesOfficeWithIdAppointment(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.serviceList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addDoctor(officeId, doctor) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postDoctorOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(doctor),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.doctorId;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  updateDoctor(officeId, doctorId, doctor) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postDoctorOfficeWithIdWithDoctorId(
            {
              id: officeId,
              doctorId
            },
            swaggerClient.buildRequest(doctor),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  deleteDoctor(doctorId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.deleteDoctorWithDoctorId(
            {
              doctorId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function () {},
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  updateDoctorService(doctorService) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postDoctorServiceOffice(
            {},
            swaggerClient.buildRequest(doctorService),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  deleteDoctorService(doctorService) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.deleteDoctorServiceOffice(
            {},
            swaggerClient.buildRequest(doctorService),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addNewDoctorTimeTable(doctor) {
    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => {
          resolve(doctor);
        }, 1000);
      } catch (error) {
        reject(error);
      }
    });
  }

  // GET (SERVICE, SLOTS) TUPPLES FOR A SPECIFIC OFFICE
  fetchSlotServiceOfficeWithId(officeId, serviceId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getSlotServiceWithServiceIdOfficeWithOfficeId(
            {
              officeId: officeId,
              serviceId: serviceId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.serviceSlotList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // GET SERVICE TIMETABLE
  fetchServiceTimetable(officeId, serviceId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getTimetableServiceWithServiceIdOfficeWithOfficeId(
            {
              officeId: officeId,
              serviceId: serviceId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body.timeTableList;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // SAVE SERVICE TIMETABLE
  saveServiceTimetable(officeId, serviceId, timetable) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postTimetableServiceWithServiceIdOfficeWithOfficeId(
            {
              officeId: officeId,
              serviceId: serviceId
            },
            swaggerClient.buildRequest({
              ...timetable
            }),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // GET SERVICE SLOTS
  fetchServiceSlots(officeId, serviceId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getSlotServiceWithServiceIdOfficeWithOfficeId(
            {
              officeId: officeId,
              serviceId: serviceId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // SAVE SERVICE SLOTS
  saveServiceSlots(officeId, serviceId, slots) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postSlotServiceWithServiceIdOfficeWithOfficeId(
            {
              officeId: officeId,
              serviceId: serviceId
            },
            swaggerClient.buildRequest({
              ...slots
            }),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  // SAVE SERVICE
  updateService(officeId, service) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postServiceOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest({
              ...service
            }),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }
  /**
   * Save or update a service alias
   */
  saveOrUpdateServiceAlias(officeId, serviceId, alias) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postAliasServiceWithServiceIdOfficeWithOfficeId(
            {
              officeId,
              serviceId
            },
            swaggerClient.buildRequest({
              ...alias
            }),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }
  /**
   * Delete a service alias
   */
  deleteServiceAlias(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.deleteAliasServiceWithServiceIdOfficeWithOfficeId(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        function (error) {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  fetchOfficeEquipment(officeId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.getEquipmentOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  createMachinery(officeId, machinery) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postMachineryOfficeWithId(
            {
              id: officeId
            },
            swaggerClient.buildRequest(machinery),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  updateMachinery(parameters, machinery) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postMachineryOfficeWithIdWithMachineryId(
            parameters,
            swaggerClient.buildRequest(machinery),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  deleteMachinery(machineryId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.deleteMachineryWithMachineryId(
            {
              machineryId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  addMachineryService(machineryService) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.postMachineryServiceOffice(
            {},
            swaggerClient.buildRequest(machineryService),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  deleteMachineryService(machineryService) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        function (client) {
          return client.apis.HealthFacilityManagement.deleteMachineryServiceOffice(
            {},
            swaggerClient.buildRequest(machineryService),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        function (result) {
          return result.body;
        },
        function (reason) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        }
      );
  }

  generateOfficeServicesExcelFile(officeId, officeServiceIds) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityManagement.postServicesOfficeWithIdExport(
            { id: officeId },
            swaggerClient.buildRequest(officeServiceIds),
            {}
          );
        })
        .then(result => {
          resolve(result);
        })
        .catch(error => reject(error));
    });
  }

  generateOfficeDoctorsExcelFile(officeId, officeDoctorIds) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient
        .then(client => {
          return client.apis.HealthFacilityManagement.postDoctorsServiceOfficeWithIdExport(
            { id: officeId },
            swaggerClient.buildRequest(officeDoctorIds),
            {}
          );
          return Promise.resolve();
        })
        .then(result => {
          resolve(result);
        })
        .catch(error => reject(error));
    });
  }
}
